import { Link } from "react-router";
import { Input, Select } from "antd";
import SimpleTablePage from "../common/SimpleTablePage";

const columns = [
  {
    title: "ID",
    ellipsis: true,
    key: "id",
    dataIndex: "id",
    sorter: true,
    width: 70,
    render: (id) => (
      <Link to={`${id}`} onClick={(event) => event.stopPropagation()}>
        {id}
      </Link>
    ),
  },
  {
    title: "Categoria",
    ellipsis: true,
    key: "dpi",
    dataIndex: "dpi",
    render: (dpi) => dpi?.name,
    sorter: true,
    width: 150,
  },
  {
    title: "Descrizione",
    key: "description",
    dataIndex: "description",
    sorter: true,
    ellipsis: true,
    width: 150,
  },
  {
    title: "Fornitore",
    key: "supplier",
    dataIndex: "supplier",
    sorter: true,
    ellipsis: true,
    width: 100,
  },
  {
    title: "Cod. articolo fornitore",
    key: "supplierCode",
    dataIndex: "supplierCode",
    sorter: true,
    ellipsis: true,
    width: 100,
  },
  {
    title: "Colore",
    key: "color",
    dataIndex: "color",
    sorter: true,
    ellipsis: true,
    width: 100,
  },
  {
    title: "Taglia",
    key: "size",
    dataIndex: "size",
    sorter: true,
    ellipsis: true,
    width: 100,
  },
  {
    title: "Giacenza",
    key: "inventoryAmount",
    dataIndex: "inventoryAmount",
    sorter: true,
    ellipsis: true,
    width: 100,
  },
];

const filterItems = [
  ...[
    ["sku", "Codice articolo"],
    ["description", "Descrizione"],
    ["supplier", "Fornitore"],
    ["supplierCode", "Cod. articolo fornitore"],
    ["color", "Colore"],
    ["size", "Taglia"],
  ].map(([name, label]) => ({
    name,
    label,
    formItem: { children: <Input allowClear /> },
  })),
  {
    name: "trackingType",
    label: "Tracciamento",
    readableValue: (value) => ({ SERIAL: "Matricola", QUANTITY: "Quantità" })[value],
    formItem: {
      children: (
        <Select
          allowClear
          options={[
            { label: "Matricola", value: "SERIAL" },
            { label: "Quantità", value: "QUANTITY" },
          ]}
        />
      ),
    },
  },
];

export default function DpiProducts() {
  return (
    <SimpleTablePage
      resource="dpiProduct"
      columns={columns}
      filterItems={filterItems}
      title="Prodotti DPI"
      description={"Gestisci i prodotti e verifica le giacenze"}
    />
  );
}
